import { EditOutlined} from "@ant-design/icons";
import { Space, Table, Drawer , Button, Tag } from 'antd';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import accountService from "../../../api/account.service";

import { ADD_MODE, DEFAULT_MASTER_DRAWER_WIDTH, EDIT_MODE, GREEN_TAG, RED_TAG } from '../../../utility/Constants';
import DrawableCloseIcon from "../../common/DrawableCloseIcon";
import GstEntry from "./GstEntry";

const GstList = () => {
  const state = useSelector((state)=>state.gst)
    const [visible, setVisible] = useState(false);

    const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
    const [page, setPage] = React.useState(1);
    
    const [gstList, setGstList] = useState([]);
    const [gstData, setGstData] = useState({
      id: 0,
      gstDescription: '',
      gstType: '',
      rate: '',
      accountId: '',
      usedfor: '',
      mode: EDIT_MODE
    });
  
    const showDrawer = (rowdata) => {
    
      setGstData({
        id : rowdata.id,
        gstDescription: rowdata.gstDescription,
        gstType:rowdata.gstType,
        rate:rowdata.rate,
        accountId: rowdata.accountId,
        usedfor: rowdata.usedfor,
        mode: EDIT_MODE
    })
  
      setVisible(true);
  
    };
  
  
    const onClose = () => {
      setVisible(false);
    };
  
  
    
  
  
    const columns = [
      { 
        title: '#', 
        dataIndex: 'index', 
        render: (text, record, index) => (page - 1) * 10 + ++index ,
        width: '5%',
      },
      {
        title: 'Description',
        dataIndex: 'gstDescription',
        key: 'gstDescription',
        sorter: (a, b) => a.gstDescription.localeCompare(b.gstDescription),
      },
      {
        title: 'Type',
        dataIndex: 'gstType',
        key: 'gstType',
        sorter: (a, b) => a.gstType.localeCompare(b.gstType),
      },
      {
        title: 'Rate',
        dataIndex: 'rate',
        key: 'rate',
        align:'right',
        sorter: (a, b) => a.rate - b.rate,
      },
      {
        title: 'Account',
        dataIndex: 'account_name',
        key: 'account_name',
        sorter: (a, b) => a.account_name.localeCompare(b.account_name),
      },
      {
        title: 'Used For',
        dataIndex: 'usedfor',
        key: 'usedfor',
        render: (selectedObj,record) => (
          <Space size="middle">
            {
              record.usedfor == "O" ? <><Tag color={GREEN_TAG}>Output</Tag></> : <><Tag color={RED_TAG}>Input</Tag></>
            }
          </Space>
        )
      },
      {
        title: 'Action',
        key: 'action',
        width:'10%',
        render: (selectedObj) => (
          
          <Space size="middle">
            {/* <a onClick={()=> showDrawer(selectedObj)}>Edit {selectedObj.component_id}</a> */}
            <Button htmlType="button" type="ghost" size="small" shape="round" onClick={()=> showDrawer(selectedObj)}>Edit <EditOutlined /></Button>
          </Space>
        ),
      },
    ];
  
  
    useEffect(() => {
      accountService.gstList().then((res) => {
        // console.log(res.data.response_data);
        setGstList(res.data.response_data);
      });
    }, [state.gst])
  
    return (
      <>
        <Table 
          columns={columns} 
          rowKey='id' 
          dataSource={gstList} 
          pagination={{
            showTotal,
            onChange(current) {
              setPage(current);
            }
          }}
          size="small"
        />
  
        <Drawer
            title="Edit GST"
            width={DEFAULT_MASTER_DRAWER_WIDTH}
            onClose={onClose}
            visible={visible}
            bodyStyle={{
              paddingBottom: 80,
            }}
            destroyOnClose = {true}
            closeIcon = {<><DrawableCloseIcon /></>}
          >
            <GstEntry data={gstData} onDrawerClose={onClose}/>
          </Drawer>
  
      </>
    );
}

export default GstList